module.exports = __webpack_public_path__ + "img/cycle_trois_continents.8054b1be.jpg";